import React from 'react';
import Header from '../components/Header';
import Hero from '../components/Hero';
import Footer from '../components/Footer';

function Home() {
  return (
    <>
      <Header />
      <main className="main">
        <Hero />
      </main>
      <Footer />
    </>
  );
}

export default Home;
